<template>
  <div class="map-container">
    <GisMap ref="gisMap" @feature-selected="handleFeatureSelected" @clear-vector-layer="handleClearVectorLayer" />
    <div class="scaled-components" :style="containerStyle">
      <LegengMap ref="legengMap" z-index="1000" @layer-click="handleLayerClick"
        @selected-id-change="handleSelectedIdChange" @scale-to-ratio="handleScaleToRatio" />
      <InfoMap ref="infoMap" @close-overlay="handleCloseOverlay" />
      <BottomMap @layer-change="handleLayerChange" @show-legend="handleShowLegend" @positioning="handlePositioning"
        @query-search="handleQuerySearch" @clear-layer="handleClearLayer" @tool-click="handleToolClick"
        @location-map="handleLocationMap" />
      <QueryMap @result-selected="handleResultSelected" @clear-search="handleClearSearch" />
      <Scalebar />
      <ToolContainer :visible="toolContainerVisible" :tool-list="currentToolList" :active-tool-type="activeToolType"
        @tool-item-click="handleToolItemClick" @delete-tool="handleDeleteTool" />
    </div>
  </div>
</template>


<script>
import GisMap from './newBigMapModule/gisMap.vue'
import LegengMap from './newBigMapModule/legengMap.vue'
import InfoMap from './newBigMapModule/infoMap.vue'
import BottomMap from './newBigMapModule/bottomMap.vue'
import QueryMap from './newBigMapModule/queryMap.vue'
import Scalebar from './mapModule/Scalebar.vue'
import ToolContainer from './mapModule/ToolContainer.vue'
export default {
  name: 'BigMap',
  components: {
    GisMap,
    LegengMap,
    InfoMap,
    BottomMap,
    QueryMap,
    Scalebar,
    ToolContainer
  },
  data () {
    return {
      // 屏幕适配相关数据
      screenWidth: window.innerWidth,
      screenHeight: window.innerHeight,
      scaleRatio: 1,
      // 基准屏幕尺寸（设计稿尺寸）
      baseWidth: 1920,
      baseHeight: 1080,
      // 最小和最大缩放比例
      minScale: 0.5,
      maxScale: 2.0,
      // 工具容器相关数据
      toolContainerVisible: false,
      currentToolList: [],
      activeToolType: null
    };
  },
  computed: {
    // 计算容器样式，包含缩放变换
    containerStyle () {
      return {
        transform: `scale(${this.scaleRatio})`,
        transformOrigin: 'top left',
        width: `${100 / this.scaleRatio}%`,
        height: `${100 / this.scaleRatio}%`
      };
    }
  },
  mounted () {
    this.initScreenAdaptation();
    this.bindResizeEvent();
    // 监听工具容器状态变化
    this.watchToolContainer();
  },

  watch: {
    // 监听 gisMap 的工具容器状态
    '$refs.gisMap.showToolContainer' () {
      this.updateToolContainerState();
    },
    '$refs.gisMap.currentToolList' () {
      this.updateToolContainerState();
    },
    '$refs.gisMap.activeToolType' () {
      this.updateToolContainerState();
    }
  },
  beforeDestroy () {
    this.unbindResizeEvent();
    // 清除工具容器监听
    if (this.toolContainerTimer) {
      clearInterval(this.toolContainerTimer);
    }
  },
  methods: {
    // 初始化屏幕适配
    initScreenAdaptation () {
      this.updateScreenSize();
      this.calculateScaleRatio();
    },

    // 更新屏幕尺寸
    updateScreenSize () {
      this.screenWidth = window.innerWidth;
      this.screenHeight = window.innerHeight;
    },

    // 计算缩放比例
    calculateScaleRatio () {
      // 计算宽高比
      const widthRatio = this.screenWidth / this.baseWidth;
      const heightRatio = this.screenHeight / this.baseHeight;

      // 使用较小的比例确保内容完全显示
      let ratio = Math.min(widthRatio, heightRatio);

      // 限制在最小和最大缩放比例之间
      ratio = Math.max(this.minScale, Math.min(this.maxScale, ratio));

      this.scaleRatio = ratio;

      console.log('屏幕适配信息:', {
        screenSize: `${this.screenWidth}x${this.screenHeight}`,
        baseSize: `${this.baseWidth}x${this.baseHeight}`,
        scaleRatio: this.scaleRatio
      });
    },

    // 绑定窗口大小变化事件
    bindResizeEvent () {
      this.handleResize = this.debounce(() => {
        this.updateScreenSize();
        this.calculateScaleRatio();
      }, 100);

      window.addEventListener('resize', this.handleResize);
    },

    // 解绑窗口大小变化事件
    unbindResizeEvent () {
      if (this.handleResize) {
        window.removeEventListener('resize', this.handleResize);
      }
    },

    // 防抖函数
    debounce (func, wait) {
      let timeout;
      return function executedFunction (...args) {
        const later = () => {
          clearTimeout(timeout);
          func(...args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
      };
    },

    // 监听工具容器状态
    watchToolContainer () {
      // 使用 setInterval 轮询检查状态（因为 watch 可能无法监听到深层属性）
      this.toolContainerTimer = setInterval(() => {
        this.updateToolContainerState();
      }, 100);
    },


    handleLayerClick (item, index, selected) {
      console.log('图层点击:', item, index, selected)

      // 直接调用 GisMap 的方法
      if (this.$refs.gisMap && this.$refs.gisMap.handleLayerSelected) {
        this.$refs.gisMap.handleLayerSelected(item);
      }
    },

    handleSelectedIdChange (data) {
      console.log('selectedID 变化:', data)

      // 将 selectedID 传递给 GisMap
      if (this.$refs.gisMap && this.$refs.gisMap.handleSelectedIdChange) {
        this.$refs.gisMap.handleSelectedIdChange(data);
      }
    },

    // 处理缩放到指定比例事件
    handleScaleToRatio (data) {
      console.log('缩放到比例:', data);
      // 将缩放事件传递给 GisMap
      if (this.$refs.gisMap && this.$refs.gisMap.scaleToRatio) {
        this.$refs.gisMap.scaleToRatio(data);
      }
    },

    handleFeatureSelected (feature) {
      console.log('要素选择事件:', feature)

      // 将要素数据传递给 InfoMap
      if (this.$refs.infoMap && this.$refs.infoMap.handleFeatureData) {
        this.$refs.infoMap.handleFeatureData(feature);
      }
    },

    handleLayerChange (data) {
      console.log('图层变化:', data)

      // 将图层数据传递给 GisMap
      if (this.$refs.gisMap && this.$refs.gisMap.handleLayerChange) {
        this.$refs.gisMap.handleLayerChange(data);
      }
    },
    handleShowLegend () {
      console.log('图例变化')

      if (this.$refs.legengMap && this.$refs.legengMap.handleShowLegend) {
        this.$refs.legengMap.handleShowLegend();
      }
    },

    handleCloseOverlay () {
      console.log('接收到关闭覆盖层事件')

      // 调用 GisMap 的关闭覆盖层方法
      if (this.$refs.gisMap && this.$refs.gisMap.handleCloseOverlay) {
        this.$refs.gisMap.handleCloseOverlay();
      }
    },

    handlePositioning () {
      console.log('接收到定位事件')

      // 调用 GisMap 的定位方法
      if (this.$refs.gisMap && this.$refs.gisMap.handlePositioning) {
        this.$refs.gisMap.handlePositioning();
      }
    },
    handleQuerySearch (queryParams) {
      console.log('接收到查询事件:', queryParams)

      // 将查询事件传递给 GisMap
      if (this.$refs.gisMap && this.$refs.gisMap.handleQuerySearch) {
        this.$refs.gisMap.handleQuerySearch(queryParams);
      }
    },

    handleClearLayer (layerId) {
      console.log('接收到清除图层事件:', layerId);

      // 将清除图层事件传递给 GisMap
      if (this.$refs.gisMap && this.$refs.gisMap.clearLayerById) {
        this.$refs.gisMap.clearLayerById(layerId);
      }
    },

    handleClearVectorLayer () {
      console.log('接收到清除矢量图层事件');

      // 通知 InfoMap 隐藏详情面板
      if (this.$refs.infoMap) {
        this.$refs.infoMap.contentInfoShow = false;
      }
    },

    handleResultSelected (result) {
      console.log('接收到搜索结果事件:', result);

      // 将搜索结果事件传递给 GisMap
      if (this.$refs.gisMap && this.$refs.gisMap.handleResultSelected) {
        this.$refs.gisMap.handleResultSelected(result);
      }
    },

    handleClearSearch () {
      console.log('接收到清除搜索事件');

      // 将清除搜索事件传递给 GisMap
      if (this.$refs.gisMap && this.$refs.gisMap.handleClearSearch) {
        this.$refs.gisMap.handleClearSearch();
      }
    },

    handleToolClick (key) {
      console.log('接收到工具点击事件:', key);

      // 将工具点击事件传递给 GisMap
      if (this.$refs.gisMap && this.$refs.gisMap.handleToolClick) {
        this.$refs.gisMap.handleToolClick(key);
        // 同步工具容器状态
        this.$nextTick(() => {
          this.updateToolContainerState();
        });
      }
    },

    // 更新工具容器状态
    updateToolContainerState () {
      if (this.$refs.gisMap) {
        this.toolContainerVisible = this.$refs.gisMap.showToolContainer || false;
        this.currentToolList = this.$refs.gisMap.currentToolList || [];
        this.activeToolType = this.$refs.gisMap.activeToolType || null;
      }
    },

    // 处理工具项点击
    handleToolItemClick (item) {
      if (this.$refs.gisMap && this.$refs.gisMap.handleToolItemClick) {
        this.$refs.gisMap.handleToolItemClick(item);
        // 同步状态
        this.$nextTick(() => {
          this.updateToolContainerState();
        });
      }
    },

    // 处理删除工具
    handleDeleteTool () {
      if (this.$refs.gisMap && this.$refs.gisMap.handleDeleteTool) {
        this.$refs.gisMap.handleDeleteTool();
        // 同步状态
        this.$nextTick(() => {
          this.updateToolContainerState();
        });
      }
    },

    handleLocationMap (locationData) {
      console.log('接收到地图定位事件:', locationData);

      // 调用 GisMap 的定位方法
      if (this.$refs.gisMap && this.$refs.gisMap.setMapLocation) {
        this.$refs.gisMap.setMapLocation(locationData.longitude, locationData.latitude);
      }
    }
  }
}
</script>


<style lang="less" scoped>
.map-container {
  width: 100%;
  height: 100%;
  position: relative;
  overflow: hidden;
}

.scaled-components {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none; // 让点击事件穿透到地图
  z-index: 1000;

  // 确保子组件可以接收点击事件
  >* {
    pointer-events: auto;
  }
}

// 响应式断点
@media (max-width: 1920px) {
  .scaled-components {
    transform-origin: center center;
  }
}

@media (max-width: 1440px) {
  .scaled-components {
    transform-origin: center center;
  }
}

@media (max-width: 1024px) {
  .scaled-components {
    transform-origin: center center;
  }
}

@media (max-width: 768px) {
  .scaled-components {
    transform-origin: center center;
  }
}

@media (max-width: 480px) {
  .scaled-components {
    transform-origin: center center;
  }
}
</style>